// Story Survey - Webhook-basierte Speicherlösung
// Sendet an externe Services OHNE das Shopify Contact Form zu nutzen

class StorySurveyWebhook {
  constructor() {
    this.surveyLogic = window.storySurvey;
    if (!this.surveyLogic) return;
    
    this.orderId = new URLSearchParams(window.location.search).get('order_id');
    this.init();
  }

  init() {
    const originalSubmit = this.surveyLogic.submitSurvey.bind(this.surveyLogic);
    
    this.surveyLogic.submitSurvey = async (e) => {
      e.preventDefault();
      
      this.surveyLogic.saveCurrentAnswer();
      
      const surveyData = this.prepareSurveyData();
      
      try {
        // Try multiple save methods
        const saved = await this.saveData(surveyData);
        
        if (!saved) {
          throw new Error('Keine Speichermethode verfügbar');
        }
        
        localStorage.removeItem('story_survey_progress');
        
        this.surveyLogic.showQuestion(this.surveyLogic.questions.length - 1);
        
        const rewardBox = this.surveyLogic.container.querySelector('.reward-box');
        if (rewardBox) rewardBox.style.display = 'block';
        
        this.surveyLogic.surveyCompleted = true;
        
        this.showSuccess('Vielen Dank! Dein Feedback wurde gespeichert.');
        
      } catch (error) {
        console.error('Save failed:', error);
        
        // Always save locally as backup
        this.saveToLocalStorage(surveyData);
        
        this.showError('Feedback wurde lokal gespeichert. Wir verarbeiten es später.');
      }
    };
  }

  prepareSurveyData() {
    const answers = this.surveyLogic.answers;
    
    return {
      orderId: this.orderId,
      orderNumber: this.orderId, // for compatibility
      timestamp: new Date().toISOString(),
      rating: answers.overall_rating || '',
      recommend: answers.would_recommend || '',
      storyQuality: answers.story_quality || '',
      personalization: answers.personalization_correct || '',
      issues: answers.issues || [],
      likes: answers.likes || [],
      audioSoundeffects: answers.audio_soundeffects || '',
      audioMusic: answers.audio_music || '',
      audioVoice: answers.audio_voice || '',
      personalizationIssues: answers.personalization_issues || '',
      suggestions: answers.improvement_suggestions || '',
      device: this.getDevice(),
      url: window.location.href
    };
  }

  async saveData(data) {
    // Try different save methods in order
    
    // 1. Try Zapier webhook (if configured)
    if (window.SURVEY_WEBHOOK_URL) {
      try {
        const response = await fetch(window.SURVEY_WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
          mode: 'no-cors' // Avoid CORS issues
        });
        return true;
      } catch (e) {
        console.log('Webhook failed:', e);
      }
    }
    
    // 2. Try Google Forms (if configured)
    if (window.GOOGLE_FORM_ID && window.GOOGLE_FORM_ENTRIES) {
      try {
        const formData = new URLSearchParams();
        formData.append(window.GOOGLE_FORM_ENTRIES.orderId, data.orderId);
        formData.append(window.GOOGLE_FORM_ENTRIES.rating, data.rating);
        formData.append(window.GOOGLE_FORM_ENTRIES.recommend, data.recommend);
        formData.append(window.GOOGLE_FORM_ENTRIES.feedback, JSON.stringify(data));
        
        await fetch(`https://docs.google.com/forms/d/e/${window.GOOGLE_FORM_ID}/formResponse`, {
          method: 'POST',
          body: formData,
          mode: 'no-cors'
        });
        return true;
      } catch (e) {
        console.log('Google Forms failed:', e);
      }
    }
    
    // 3. Try custom endpoint (if configured)
    if (window.SURVEY_ENDPOINT) {
      try {
        const response = await fetch(window.SURVEY_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
        return response.ok;
      } catch (e) {
        console.log('Custom endpoint failed:', e);
      }
    }
    
    // 4. Fallback to localStorage only
    this.saveToLocalStorage(data);
    return true;
  }

  saveToLocalStorage(data) {
    const key = `survey_${this.orderId}_${Date.now()}`;
    localStorage.setItem(key, JSON.stringify(data));
    localStorage.setItem(`survey_completed_${this.orderId}`, 'true');
    
    // Also save a list of all surveys for easy retrieval
    const allSurveys = JSON.parse(localStorage.getItem('all_story_surveys') || '[]');
    allSurveys.push({
      key: key,
      orderId: data.orderId,
      timestamp: data.timestamp,
      rating: data.rating
    });
    localStorage.setItem('all_story_surveys', JSON.stringify(allSurveys));
  }

  getDevice() {
    const width = window.innerWidth;
    if (width < 768) return 'mobile';
    if (width < 1024) return 'tablet';
    return 'desktop';
  }

  showSuccess(message) {
    this.showNotification(message, '#28a745');
  }

  showError(message) {
    this.showNotification(message, '#ff4444');
  }

  showNotification(message, color) {
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${color};
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      z-index: 10000;
      font-weight: 500;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 4000);
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    window.storySurveyWebhook = new StorySurveyWebhook();
  }, 100);
});